import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-profile-menu]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`.profile-image { font-size: 36px; color: white; }`],
  template: `
  <a href="#" (click)="iconClick.emit($event)">
    <i class="fa fa-user-circle-o profile-image"></i>
    <span class="topbar-item-name">{{userFullname}}
      <span class="topbar-item-role">{{userLogin}}</span>
    </span>
  </a>
  <ul class="layout-menu fadeInDown">
    <ng-content></ng-content>
    <li role="menuitem">
      <a href="#" (click)="onLogoutClick($event)">
        <i class="fa fa-fw fa-sign-out"></i>
        <span>Esci</span>
      </a>
    </li>
  </ul>
  `
})

export class ProfileMenuComponent {
  @Input() userFullname: string | undefined;
  @Input() userLogin: string | undefined;
  @Output() iconClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() logout = new EventEmitter();

  onLogoutClick(e: MouseEvent): void {
    e.preventDefault();
    this.logout.emit();
  }
}
